<mat-toolbar class="p-0 mat-elevation-z1">

  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

      <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar"
        (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>

      <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
        <div class="logo ml-16" [routerLink]="['/']">
          <img class="logo-icon" src="assets/images/ets-logo-navy.svg" (click)="onLogoClick($event)" >
          <span class="logo-text ml-16"><strong>CBCIS</strong><span class="ml-8 mat-caption hint-text"></span></span>
        </div>
      </div>

      <!-- <div *ngIf="navigation" class="px-8 px-md-16">
                <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
            </div> -->

    </div>

    <div class="mr-28" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

      <button mat-icon-button class="help-button mr-16" (click)="onHelp()" aria-label="Help">
        <fa-icon class="font-size-20 mr-8 secondary-icon-color" [icon]="fa.faQuestionCircle"></fa-icon>
        <span>Help</span>
      </button>

      <div class="toolbar-separator primary h-28"></div>


      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button ml-8">
        <div fxLayout="row" fxLayoutAlign="center center">
          <fa-icon class="font-size-20 mr-8 secondary-icon-color" [icon]="faSolid.faUserCircle"></fa-icon>
          <span class="username mr-12" fxHide fxShow.gt-sm>{{userEmail}}</span>
          <!-- <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon> -->
          <fa-icon class="font-size-14 secondary-icon-color" [icon]="faSolid.faChevronDown"></fa-icon>
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

        <button mat-menu-item class="" (click)="onLogoutClick()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>

      </mat-menu>

      <!-- <div class="toolbar-separator"></div> -->

      <!-- THEME OPTIONS PANEL -->
      <!-- <button mat-icon-button class="theme-options-button"
                (click)="toggleSidebarOpen('themeOptionsPanel')">
                <mat-icon>settings</mat-icon>
            </button> -->


    </div>

  </div>

</mat-toolbar>
